// src/workers/pdfParserInstance.ts

let pdfParserWorker: Worker | null = null;

export const getPdfParserWorker = () => {
    try {
        if (!pdfParserWorker) {
            console.log('[System] Spawning PDF Parser Worker Instance...');
            pdfParserWorker = new Worker(
                new URL('./pdfParser.worker.ts', import.meta.url),
                { type: 'module', name: 'pdf-parser-worker' }
            );

            pdfParserWorker.onerror = (err) => {
                console.error('[Parser Worker Error] Thread crashed or failed to load:', err);
                // If the worker fails to load (common in first-time Vite runs), 
                // we clear the instance so it can try again next time.
                pdfParserWorker = null;
            };

            console.log('[System] PDF Parser Worker initialized successfully.');
        }
        return pdfParserWorker;
    } catch (error) {
        console.error('[System] Critical error spawning PDF Parser Worker:', error);
        return null;
    }
};

export const terminatePdfParserWorker = () => {
    if (pdfParserWorker) {
        pdfParserWorker.terminate();
        pdfParserWorker = null;
    }
};
